import feathersClient, {BaseModel, makeServicePlugin} from '../../feathers-client'

class AppEvent extends BaseModel {
    constructor(data, options) {
        super(data, options)
    }

    // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = 'AppEvent';

    // Define default properties here
    static instanceDefaults() {
        return {
            name: '',
            mobileAppId: null,
            eventId: null,
            order: 0,
        }
    }
}

const servicePath = 'apps-events';
const servicePlugin = makeServicePlugin({
    Model: AppEvent,
    service: feathersClient.service(servicePath),
    servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
    before: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    after: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    error: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    }
});

export default servicePlugin